/**
 * The apex is the product's own host: it serves the HireOS identity page and
 * is the origin every outbound Customer/Contractor link points at (#221).
 * Every other host — `demo.`, `stage-and-seating.`, localhost in dev — is a
 * tenant surface whose `/` is the inquiry flow.
 *
 * Deliberately an exact match rather than a suffix test: `tenantSlugFromHost`
 * returns null for localhost too, and treating dev as the apex would move the
 * whole local flow off `/inquiry` for no reason.
 */
const PUBLIC_SITE_HOSTS = new Set(["hireos.co.nz", "www.hireos.co.nz"]);

export function isPublicSiteHost(hostname: string): boolean {
  return PUBLIC_SITE_HOSTS.has(
    hostname.trim().toLowerCase().replace(/\.$/, ""),
  );
}
